export const UPDATE_CONSOLE_INFO = '@@console/update'
export const RESET_CONSOLE_INFO = '@@console/reset'
